module.exports = __webpack_public_path__ + "static/media/Home delivery new icon.d5847789.svg";